export default __webpack_public_path__ + "static/michelin-hero-vid-48b2ac137f693044f27608b13d6361b0.mp4";